import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';

import appointmentTypesResource from '@lib/resources/appointmentTypesResource';
import { AppointmentType } from '@lib/resources/types';

import { removeSpecialCharacters } from 'ui-utils';

import FilterList, { FilterListProps } from '../FilterList';
import messages from '../messages';

import { resultKey, selectAppointmentTypes } from './selectors';

interface Props extends FilterListProps {
  items: AppointmentType[];
  dispatch: Dispatch;
  respectSchedulerSetting?: boolean;
}

const FilterListAppointmentTypes: React.FC<Props> = ({
  allItems,
  items,
  dispatch,
  idsExcluded,
  respectSchedulerSetting = false,
  ...other
}) => {
  useEffect(() => {
    dispatch(
      appointmentTypesResource.fetchBulk({
        ids: idsExcluded,
      }),
    );
  }, [dispatch, idsExcluded]);

  return (
    <FilterList
      patternEnforcer={removeSpecialCharacters}
      itemsLabel={messages.appointmentTypeItemsLabel}
      allItems={allItems}
      items={items}
      idsExcluded={idsExcluded}
      // @ts-ignore
      onSearchChange={(page, limit, name) => {
        const params: any = { page, limit, name };

        if (respectSchedulerSetting) {
          params['settings.scheduler.enabled'] = true;
        }

        dispatch(
          appointmentTypesResource.fetchPage({
            params,
            meta: {
              resultKey,
            },
          }),
        );
      }}
      // @ts-ignore
      {...other}
    />
  );
};

const withConnect = connect(
  createStructuredSelector({
    allItems: appointmentTypesResource.selectEntitiesObj,
    items: selectAppointmentTypes,
  }),
);

export default withConnect(FilterListAppointmentTypes);
